export default {

  email:(rule, value, callback) => {
    let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!reg.test(value)) {
      callback(new Error('邮箱格式不正确'))
    }else {
      callback()
    }
  },
  phone: (rule, value, callback) => {
    console.log(rule,'rule');
    let reg = /1\d{10}/;
    if (!reg.test(value)) {
      callback(new Error('手机号格式不正确'))
    }else {
      callback()
    }
  },

  idCard : (rule, value, callback) => {
    let reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (!reg.test(value)&&value) {
      callback(new Error('身份证号码格式不正确'))
    }else {
      callback()
    }
  }

};


// WEBPACK FOOTER //
// ./src/utils/validator.js